import axios from 'axios';
import React, { createContext, useState, useEffect } from 'react';

export const WishlistContext = createContext();

export const WishlistProvider = ({ children }) => {
  const [Wishlist, setWishlist] = useState([]);

  async function GetLoggedUserWishList() {
   try {
    const { data } = await axios.get('https://ecommerce.routemisr.com/api/v1/wishlist', {
      headers: {
        token: localStorage.getItem('token')
      }
    }

    )
    setWishlist(data.data)
   } catch (error) {
    console.log(error)
   }
  
}

useEffect(() => {
  GetLoggedUserWishList()
}, [])


  const addToWishlist = (product) => {
    setWishlist((prevWishlist) => [...prevWishlist, product]);
  };

  const removeFromWishlist = (productId) => {
    setWishlist((prevWishlist) =>
      prevWishlist.filter((product) => product.id !== productId)
    );
  };

  const isInWishlist = (productId) => {
    return Wishlist.some((product) => product.id === productId);
  };

  // Save wishlist data to localStorage whenever the wishlist state changes
  useEffect(() => {
    localStorage.setItem('wishlist', JSON.stringify(Wishlist));
  }, [Wishlist]);

  // Load wishlist data from localStorage when the component mounts
  useEffect(() => {
    const storedWishlist = localStorage.getItem('wishlist');
    if (storedWishlist) {
      setWishlist(JSON.parse(storedWishlist));
    }
  }, []);

  return (
    <WishlistContext.Provider
      value={{
        Wishlist,
        addToWishlist,
        removeFromWishlist,
        isInWishlist,
      }}
>
      {children}
    </WishlistContext.Provider>
  );
};